import React, { useState } from 'react';
import { Download, Share, SquarePlus, MonitorDown } from 'lucide-react';
import Modal from './Modal';
import { usePwaInstall } from '../hooks/usePwaInstall';

interface InstallAppButtonProps {
  isExpanded?: boolean;
  onAction?: () => void;
}

const InstallAppButton: React.FC<InstallAppButtonProps> = ({ isExpanded = true, onAction }) => {
  const { mode, canInstall, promptInstall } = usePwaInstall();
  const [showInstructions, setShowInstructions] = useState(false);

  if (!canInstall && !showInstructions) return null;

  const handleClick = () => {
    onAction?.();
    if (mode === 'native') {
      promptInstall();
    } else {
      setShowInstructions(true);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        title={!isExpanded ? 'Instalar aplicativo' : ''}
        className={`group w-full flex items-center ${isExpanded ? 'gap-3 px-3' : 'justify-center px-0'} py-2.5 text-sm rounded-lg border border-bordo/25 bg-bordo/5 text-tinta hover:bg-bordo/10 hover:border-bordo/50 transition-colors`}
      >
        <Download className="h-5 w-5 text-bordo flex-shrink-0" />
        {isExpanded && (
          <div className="flex-1 min-w-0 text-left">
            <p className="text-sm font-bold text-tinta leading-tight">Instalar aplicativo</p>
            <p className="text-[11px] text-tinta-soft italic leading-tight">Acesse direto da tela inicial</p>
          </div>
        )}
      </button>

      <Modal
        isOpen={showInstructions}
        onClose={() => setShowInstructions(false)}
        title="Instalar a Roda de Prêmios"
        size="sm"
      >
        <div className="flex items-center gap-3 mb-5">
          <img src="/pwa-192.png" alt="" className="h-14 w-14 rounded-xl shadow-sm" />
          <p className="text-sm text-tinta-soft">
            Tenha a Roda de Prêmios como um aplicativo, com ícone próprio e acesso em um toque.
          </p>
        </div>

        {mode === 'safari-mac' ? (
          <ol className="space-y-3 text-sm text-tinta">
            <li className="flex items-start gap-3">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-bordo/10 text-bordo font-bold text-xs">1</span>
              <span>No menu do Safari, clique em <strong>Arquivo</strong>.</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-bordo/10 text-bordo font-bold text-xs">2</span>
              <span className="flex items-center gap-1.5 flex-wrap">
                Escolha <MonitorDown className="h-4 w-4 text-bordo" /> <strong>Adicionar ao Dock</strong>.
              </span>
            </li>
          </ol>
        ) : (
          <ol className="space-y-3 text-sm text-tinta">
            <li className="flex items-start gap-3">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-bordo/10 text-bordo font-bold text-xs">1</span>
              <span className="flex items-center gap-1.5 flex-wrap">
                Toque no botão <Share className="h-4 w-4 text-bordo" /> <strong>Compartilhar</strong> do navegador.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-bordo/10 text-bordo font-bold text-xs">2</span>
              <span className="flex items-center gap-1.5 flex-wrap">
                Escolha <SquarePlus className="h-4 w-4 text-bordo" /> <strong>Adicionar à Tela de Início</strong>.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-bordo/10 text-bordo font-bold text-xs">3</span>
              <span>Toque em <strong>Adicionar</strong> no canto superior.</span>
            </li>
          </ol>
        )}

        <button
          onClick={() => setShowInstructions(false)}
          className="mt-6 w-full px-4 py-2.5 bg-bordo hover:bg-bordo-dark text-creme text-sm font-bold rounded-lg transition-colors"
        >
          Entendi
        </button>
      </Modal>
    </>
  );
};

export default InstallAppButton;
